import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function ReportHeader({ timeZone }: { timeZone: string }) {
  const { t, i18n } = useTranslation();
  const [actualDate, setActualDate] = useState('');

  useEffect(() => {
    const date = new Date();
    // Usa la zona seleccionada para que la fecha del informe coincida con la aplicación.
    setActualDate(
      new Intl.DateTimeFormat(i18n.language, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone,
      }).format(date)
    );
  }, [i18n.language, timeZone]);

  return (
    <div
      className="flex align-items-center flex-column md:flex-row md:justify-content-between p-3 my-4"
      style={{ pageBreakBefore: 'always' }}
    >
      <img
        src="/assets/marsi-azul-degradado-fondo-blanco.webp"
        style={{ width: '380px' }}
        alt="Logotipo de Marsinet"
        rel="preload"
      />
      <div className="surface-ground p-3 border-round-3xl text-600 text-center md:text-right">
        {t('pages.reports.createAt')} :{' '}
        <span className="font-bold text-xl">{actualDate}</span>
      </div>
    </div>
  );
}

export default ReportHeader;

export interface DataLastSessionReceived {
  steps: number;
  time: number;
  score: number;
  walking: number;
  standing: number;
  rom: {
    ci: number;
    cd: number;
    ri: number;
    rd: number;
  };
  torque: {
    ci: number;
    cd: number;
    ri: number;
    rd: number;
  };
}

export interface DataSessionsLastMonth {
  steps: number;
  last_date: string;
  time: number;
  num_sessions: number;
  score: number;
}

export interface DataSessionsMadeFromTheStart {
  steps: number;
  last_date: string;
  time: number;
  num_sessions: number;
  score: number;
}
